import { useEffect, useRef } from 'react'
import { useScheduleDraft } from '../context/ScheduleDraftProvider'
import { setSchedulingEngineDraft } from 'routes/Studies/routes/Study/routes/Instruments/routes/Instrument/modules/Instrument'

export const usePersistSchedulingEngineDraft = ({ instrumentId, dispatch }) => {
  const { state } = useScheduleDraft()
  const latestRef = useRef({ instrumentId, schedules: state.schedules, activeScheduleId: state.activeScheduleId })

  useEffect(() => {
    latestRef.current = {
      instrumentId,
      schedules: state.schedules,
      activeScheduleId: state.activeScheduleId,
    }
  }, [instrumentId, state.schedules, state.activeScheduleId])

  useEffect(() => {
    if (!instrumentId || !state.schedules?.length || state.saving) return
    dispatch(
      setSchedulingEngineDraft({
        instrumentId,
        schedules: state.schedules,
        activeScheduleId: state.activeScheduleId,
      }),
    )
  }, [dispatch, instrumentId, state.activeScheduleId, state.saving, state.schedules])

  useEffect(() => {
    return () => {
      const { instrumentId: id, schedules, activeScheduleId } = latestRef.current
      if (!id || !schedules?.length) return
      dispatch(
        setSchedulingEngineDraft({
          instrumentId: id,
          schedules,
          activeScheduleId,
        }),
      )
    }
  }, [dispatch])
}
